export const SIZE_CATEGORIES = [
	{ key: 'mini', label: 'Mini', range: [0, 25], displayRange: '0-25 sq ft' },
	{
		key: 'small',
		label: 'Small',
		range: [26, 75],
		displayRange: '26-75 sq ft',
	},
	{
		key: 'medium',
		label: 'Medium',
		range: [76, 200],
		displayRange: '76-200 sq ft',
	},
	{
		key: 'large',
		label: 'Large',
		range: [201, Infinity],
		displayRange: '201+ sq ft',
	},
];

// Helper to derive sqft numeric average or parse bucket strings like '20-37'
export function parseSqft(unit) {
	// Support either unit.sqft numeric, unit.sqftBucket string, or sizeBucket mapping
	const sqftVal = unit?.sqft || unit?.sqftBucket || unit?.squareFootage;
	if (typeof sqftVal === 'number') return sqftVal;
	if (typeof sqftVal === 'string') {
		// pattern "A-B" or single number
		const parts = sqftVal.split('-');
		if (parts.length === 2) {
			const [a, b] = parts.map((p) => Number.parseFloat(p));
			if (!Number.isNaN(a) && !Number.isNaN(b)) return (a + b) / 2; // midpoint
		}
		const single = Number.parseFloat(parts[0]);
		if (!Number.isNaN(single)) return single;
	}
	return 0; // fallback
}

export function categorizeUnit(unit) {
	const sqft = parseSqft(unit);
	return SIZE_CATEGORIES.find(
		({ range }) => sqft >= range[0] && sqft <= range[1],
	)?.key;
}
